import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Carousel } from "react-bootstrap";
import "./DiscountAndService.css";
import { CgArrowRightO } from "react-icons/cg";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function DiscountService() {

  const navigate = useNavigate();

  // screen check
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992); // mobile + tablet
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const serviceData = [
    {
      title: "Acne & Scar Treatment",
      img: "./Treatment/acne_Scar-treatment-drtruptis-clinic.png",
      desc: "Advanced solutions to reduce acne scars and restore smooth skin.",
      path: "/treatments/acne"
    },
    {
      title: "Hair Treatment",
      img: "./Treatment/hair-treatment-drTruptis-clinic.png",
      desc: "Personalized hair care for growth, strength, and nourishment.",
      path: "/treatments/hair"
    },
    {
      title: "Carbon Laser Facial",
      img: "./Treatment/carbon-facial-drTruptis-clinic.png",
      desc: "Deep cleansing facial for instant glow and rejuvenation.",
      path: "/treatments/carbonlaser"
    },
    {
      title: "Tattoo Removal",
      img: "./Treatment/tattoo-removal-drTruptis-clinic.png",
      desc: "Safe and effective laser tattoo removal sessions.",
      path: "/treatments/tattoo"
    },
    {
      title: "Antiaging",
      img: "./Treatment/anti-aging-drTruptis-clinic.png",
      desc: "Non-surgical treatments to reduce wrinkles and fine lines.",
      path: "/treatments/antiaging"
    },
    {
      title: "Laser Hair Removal",
      img: "./Treatment/laser_hair_removal_drtruptis-clinic.jpg",
      desc: "Permanent hair reduction with advanced painless technology.",
      path: "/treatments/laserhair"
    },
  ];

  return (
    <section className="discount-section py-5">
      <Container fluid className="px-4">

        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="mb-5"
        >
          <span className="hero-speacial text-uppercase">
            <strong>World Class Treatments</strong>
          </span>

          <h2 className="fw-bold text-uppercase mt-3">
            Special Offers & Services
          </h2>

          <p className="mt-3" style={{ color: "black", fontSize: "1rem" }}>
            Explore our latest discounts and professional treatments designed for your skin and hair.
          </p>
        </motion.div>


        <Row>

          {/* LEFT COLUMN */}
          <Col md={5} className="mb-4">

            <div className="d-flex align-items-center mb-3">
              <h3 className="mb-0">Offers</h3>

              <Button variant="link" size="sm">
                <CgArrowRightO
                  style={{ color: "#bc6c25", fontSize: "2.5rem", cursor: "pointer" }}
                />
              </Button>
            </div>

            <motion.div
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >

              <Carousel>

                <Carousel.Item>
                  <img
                    className="d-block w-100 rounded"
                    src="./Treatment/Offer1.jpeg"
                    alt="Offer 1"
                  />

                  <Carousel.Caption>
                    <h5 className="bg-dark bg-opacity-50 px-2 rounded">
                      20% Off Skin Treatments
                    </h5>
                  </Carousel.Caption>
                </Carousel.Item>


                {/* <Carousel.Item>
                  <img
                    className="d-block w-100 rounded"
                    src="./Treatment/laser-hair-removal-discount.jpeg"
                    alt="Offer 2"
                  />

                  <Carousel.Caption>
                    <h5 className="bg-dark bg-opacity-50 px-2 rounded">
                      Hair Packages @ ₹999
                    </h5>
                  </Carousel.Caption>
                </Carousel.Item> */}


                {/* <Carousel.Item>
                  <img
                    className="d-block w-100 rounded"
                    src="./Treatment/laser-hair-removal-discount.jpeg"
                    alt="Offer 3"
                  />

                  <Carousel.Caption>
                    <h5 className="bg-dark bg-opacity-50 px-2 rounded">
                      Festive Glow Combo
                    </h5>
                  </Carousel.Caption>
                </Carousel.Item> */}

              </Carousel>

            </motion.div>
          </Col>


          {/* RIGHT COLUMN */}
          <Col md={7}>

            <div className="d-flex align-items-center mb-3">
              <h3 className="mb-0">Services</h3>

              <Button variant="link" size="sm">
                <CgArrowRightO
                  style={{ color: "#bc6c25", fontSize: "2.5rem", cursor: "pointer" }}
                />
              </Button>
            </div>


            <Row xs={1} md={2} lg={3} className="g-4">

              {(isSmallScreen ? serviceData.slice(0,4) : serviceData).map((service, idx) => (

                <Col key={idx}>

                  <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: idx * 0.2 }}
                    viewport={{ once: true }}
                  >

                    <Card className="h-100 w-80 service-card shadow-sm">

                      <div className="card-img-wrapper">

                        <Card.Img
                          variant="top"
                          src={service.img}
                          className="service-img"
                        />

                      </div>

                      <Card.Body className="text-center">

                        <Card.Title>{service.title}</Card.Title>

                        <Card.Text className="text-muted small">
                          {service.desc}
                        </Card.Text>

                        <div className="d-flex justify-content-center gap-2 mt-3">

                          <Button variant="primary" size="sm">
                            Enquiry Now
                          </Button>

                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => navigate(service.path)}
                          >
                            Know More
                          </Button>

                        </div>

                      </Card.Body>

                    </Card>

                  </motion.div>

                </Col>

              ))}

            </Row>

          </Col>

        </Row>

      </Container>
    </section>
  );
}

export default DiscountService;